{
  "allApps": "Alle Apps",
  "back": "Zurück zur Hauptseite",
  "myApps": "Meine Apps",
  "viewMoreApps": "Ansicht mehr Apps"
}
